import router from '../router/router'
const state = {
    eventosList: [],
    identNaOperadoraFilter: null,
    identPagamentosFilter: null,
    listResponsavel: [],
    lotesPendentes: null,
    pagamentosPublicados: null,
    pagamentosEmProcessamento: null,
    recursosGlosaFilter: null,
    monitorGlosaFilter: null,
    recursosGlosaEdicaoFilter: null,
    acompanhamentoDeEnvioFilter: null,
    routes: {
        identNaOperadoraFilter: "/identificacaonaoperadora",
        identPagamentosFilter: "/recebiveis/processosdeidentificacaodepagamentos",
        lotesPendentes: "/recebiveis/lotespendentes",
        pagamentosPublicados: "/recebiveis/pagamentospublicados",
        pagamentosEmProcessamento: "/recebiveis/pagamentosemprocessamento",
        monitorGlosaFilter:"/recebiveis/monitordeglosa",
        recursosGlosaFilter: "/recebiveis/recursosdeglosa",
        recursosGlosaEdicaoFilter: "/recebiveis/recursosdeglosa/recursosdeglosaedicao",
        acompanhamentoDeEnvioFilter: "/recebiveis/recursosdeglosa/AcompanhamentoDeEnvio",
    },
    monitorRecursoGlosa: {},
}
const mutations = {
    setFilter(state, data) {
        data.grupo_economico = data.grupo_economico? data.grupo_economico : this.state.permissions.grupoEconomico
        state[data.filterName] = {...data.filterData}

        if(data.filterName == 'recursosGlosaEdicaoFilter'){
            state.routes[data.filterName] += `/${data.filterData.pagamento_id}?integral=true`;
        }
        if(data.filterName == 'acompanhamentoDeEnvioFilter'){
            state.routes[data.filterName] += `/${data.filterData.pagamento_id}`;
        }
        this.dispatch('common/setCookie', [data.filterName, JSON.stringify(data.filterData), 1]).then(
            ()=>{
                if(data.redirect == true) {
                    router.push(state.routes[data.filterName]).catch(()=>{})
                }
            }
        )
    },
    resetFilter(state, filterName) {        
        state[filterName] = null
        if(filterName == 'acompanhamentoDeEnvioFilter'){
            state.routes[filterName] = "/recebiveis/recursosdeglosa/AcompanhamentoDeEnvio"
            this.dispatch('common/setCookie', [filterName, JSON.stringify(null), 1])
        }
        if(filterName == 'recursosGlosaEdicaoFilter'){
            state.routes[filterName] = "/recebiveis/recursosdeglosa/recursosdeglosaedicao"
            this.dispatch('common/setCookie', [filterName, JSON.stringify(null), 1])
        }
    }
}
const actions = {
    async getEventos({ state }){
        let grupo_economico = this.state.permissions.grupoEconomico
        let obj = {
            url: '/api/proxy/postdata', 
            query: [{ 
                Modulo: "Recebiveis",
                Acao: "geteventos",
                Payload: { grupo_economico}
            }]
        }
        await this.dispatch("request/doRequest", obj).then(response => {
            state.eventosList = response.dados
        });
        return state.eventosList
    },
    async getFilter({ state }, cname) {
        // let filtro = null
        // if(state[cname]){
        //     filtro = state[cname]
        // } else {
        //     await this.dispatch('common/getCookie', cname).then(resp=> filtro = resp?   JSON.parse(resp) : null)
        // }
        let filtro = state[cname] != null? state[cname] : await this.dispatch('common/getCookie', cname).then(resp=> resp? JSON.parse(resp) : null)
        return filtro && filtro.grupo_economico==this.state.permissions.grupoEconomico? filtro : null
      },
    async getResponsaveis({ state }, opts) {
        let geco = opts.grupoEconomico? opts.grupoEconomico : this.state.permissions.grupoEconomico
        let obj = {
            url: '/api/proxy/postdata', 
            query: [{ 
                Modulo: "Portal",
                Acao: "getresponsaveis",
                Payload: {
                    grupo_economico: geco,
                    ...opts,
                    sem_bloqueados: opts.sem_bloqueados ? opts.sem_bloqueados : false
                },
            noLoader: true
        }]
        }
        await this.dispatch("request/doRequest", obj).then(response => {
            state.listResponsavel = response.dados
        });
    },
    async getMonitorRecursoGlosa({state}, opts) {
        let obj = {
            url: '/api/proxy/postdata', 
            query: [{ 
                Modulo: "Recebiveis",
                Acao: "getmonitorrecursoglosa",
                Payload: opts
            }]
        }
        await this.dispatch("request/doRequest", obj).then(response => {
            state.monitorRecursoGlosa = response
        });
        return state.monitorRecursoGlosa
    },
    verificaPermissaoCarteiras() {
        if( Object.keys( this.state.permissions.permissaoBase).includes('carteira') 
          && Object.keys( this.state.userData.userData.PermissaoAcoes).includes('carteira')
          && this.state.userData.userData.PermissaoAcoes.carteira.includes('getcarteiras')){
            // this.getCarteiras()
            return true
        } else {
            return false
        }
      },
} 
export default {
    namespaced: true,
    root: true,
    actions,
    mutations,
    state
};